import React from "react"
import FieldProto from "../../proto/field-proto";
import TableManager from "../../../gd-modules/table/manager/table-manager";
import ItemModel from "../../../model2/item/item-model";
import {Column} from "../../../gd-modules/manager/columns/types";

export type FieldTableCellProps = {

    className?      : string    // do we need it ?
    field           : FieldProto
    listItem        : ItemModel // vmesto model
    manager         : TableManager // TableManager OR List manager  huh !
    column          : Column        // TableColum
    style?          : style

    configOptions?  : any

    onChange?       : onChangeCallback // ? a nahrena ono

    onFocus?        : callback      // this one is used in table to prevent dnd when input in focus i.e. we want to copy current value
    onBlur?         : callback      // this one is used in table to prevent dnd when input in focus i.e. we want to copy current value
};

export type FieldTableCellState = {
    isHovered       : boolean
    showPopover     : boolean
}

export function getTableCellStyle(props:FieldTableCellProps):style {

    // this is common part for table cell
    // end common part

    const width = props.column.width ? props.column.width : props.manager.columnsManager.getColumnWidth(props.column)

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    return style
}


export default function FieldTableCell(props:FieldTableCellProps):React.ReactElement {
    // console.log(props.field.fieldId, props.field.renderComponents.tableCell)
    return <props.field.renderComponents.tableCell {...props} key={props.field.fieldId} />
}
